import React, { ReactElement } from 'react';

import { Button } from '@storeblocks/button-rebrand';
import { BRAND_LOGO_URL } from 'App/themes/themes.constants';
import { NavLink, useNavigate } from 'react-router';
import { getAppText } from 'Utils/text';
import styles from './formHeader.module.css';

export const FormHeader = (): ReactElement => {
  const navigate = useNavigate();

  return (
    <header className={styles.headerContainer}>
      <div className={styles.contentContainer}>
        <NavLink to="/">
          <img
            className={styles.logoMobile}
            src={BRAND_LOGO_URL.storebrandMobile}
            alt="Storebrand"
          />
          <img
            className={styles.logoDesktop}
            src={BRAND_LOGO_URL.storebrand}
            alt="Storebrand"
          />
        </NavLink>

        <Button
          as="button"
          size="large"
          variant="subtle"
          className="left-button"
          onClick={() => {
            navigate(-1);
          }}
        >
          {getAppText('layoutHeader.button.cancel')}
        </Button>
      </div>
    </header>
  );
};
